import styled from 'styled-components';

export const Wrapper = styled.div`
  min-width: 900px;
  max-height: 100%;
  overflow-y: hidden;
`;
